import styled from '@emotion/styled/macro';
import { Variables } from '../../base';

export const Sidebar = styled.aside`
    flex: 0 0 300px;
    min-height: 0;
    align-self: stretch;
    border-radius: 12px;
    box-shadow: ${Variables.Shadows.small}, ${Variables.Shadows.border};
    background-color: ${Variables.Colors.white};
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const SidebarHeader = styled.div`
    padding: 16px 16px 12px;
`;

export const SidebarTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${Variables.Colors.n70};
    margin-bottom: 10px;
`;

export const SearchField = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
    border: 1px solid ${Variables.Colors.n15_48};
    border-radius: 6px;
    background: ${Variables.Colors.n15_24};
`;

export const SearchInput = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 13px;
    color: ${Variables.Colors.p500};

    &::placeholder {
        color: ${Variables.Colors.n50};
    }
`;

export const WorkerList = styled.div`
    flex: 1;
    overflow-y: auto;
    max-height: calc(100vh - 260px);
    padding: 0 10px 12px;
`;

export const EmptySearchState = styled.div`
    padding: 16px 12px;
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const WorkerButton = styled.button<{ selected: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 11px;
    width: 100%;
    margin-bottom: 2px;
    padding: 11px 12px;
    border: none;
    border-radius: 8px;
    text-align: left;
    cursor: pointer;
    background: ${({ selected }) => (selected ? Variables.ThemeLight.PrimaryMild2 : 'transparent')};

    &:hover {
        background: ${({ selected }) =>
            selected ? Variables.ThemeLight.PrimaryMild2 : Variables.ThemeLight.PrimaryMild3};
    }

    &:focus-visible {
        outline: 2px solid ${Variables.Colors.b300_l62};
        outline-offset: -2px;
    }
`;

export const StatusWorkerButton = styled(WorkerButton)`
    align-items: flex-start;
`;

export const WorkerIcon = styled.span<{ selected: boolean }>`
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ selected }) => (selected ? Variables.ThemeLight.PrimaryConstant6 : Variables.Colors.n70)};
`;

/** Execution-order number (e.g. `0.015`) between the icon and the name, as in the design. */
export const WorkerOrderNumber = styled.span`
    flex: none;
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.3;
    color: ${Variables.Colors.n50};
    font-variant-numeric: tabular-nums;
`;

export const WorkerBody = styled.div`
    flex: 1;
    min-width: 0;
`;

export const WorkerName = styled.div<{ selected?: boolean }>`
    font-size: 14px;
    font-weight: 600;
    color: ${({ selected }) => (selected ? Variables.ThemeLight.PrimaryConstant6 : Variables.Colors.p500)};
    line-height: 1.3;
`;

export const WorkerSubtitle = styled.div`
    margin-top: 2px;
    font-size: 12px;
    color: ${Variables.Colors.n70};
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const WorkerMeta = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 7px;
`;

export const StatusDot = styled.span<{ configured: boolean }>`
    flex: none;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ configured }) => (configured ? Variables.ThemeLight.SuccessConstant6 : Variables.Colors.n50)};
`;

export const MetaLabel = styled.span`
    font-size: 12px;
    color: ${Variables.Colors.n70};
    font-variant-numeric: tabular-nums;
`;

export const RuleCountDot = styled.span<{ active: boolean }>`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ active }) => (active ? Variables.ThemeLight.SuccessConstant6 : Variables.Colors.n50)};
`;
